import styled from 'styled-components';

interface IconProps {
  url: string;
  height: number;
  width: number;
}

const Icon = styled.div<IconProps>`
  background: url(${({ url }) => url}) center center / contain no-repeat;
  height: ${({ height }) => height}px;
  width: ${({ width }) => width}px;
  align-self: center;
`;

export default Icon;
